


















































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { mapState, mapActions } from 'vuex';
import { STORE_KEY, store } from './_store';

@Component({
  computed: {
    ...mapState(STORE_KEY, ['loaded', 'loading', 'fatalError', 'documents', 'lastMeta', 'retryingLogId'])
  },
  methods: {
    ...mapActions(STORE_KEY, ['loadLogs', 'retryLog'])
  }
})
export default class DbSyncLogs extends Vue {
  @Prop({ required: true }) configId!: number;
  @Prop({ required: true }) schemaCode!: string;

  loaded!: boolean;
  loading!: boolean;
  fatalError!: boolean;
  documents!: any[];
  lastMeta!: any;
  retryingLogId!: number | null;
  loadLogs!: (params: any) => Promise<any>;
  retryLog!: (params: any) => Promise<any>;

  currentPage = 1;

  created() {
    if (!(this.$store as any).hasModule(STORE_KEY)) {
      this.$store.registerModule(STORE_KEY, store);
    }
    this.loadLogs({ configId: this.configId, page: 1 });
  }

  beforeDestroy() {
    if ((this.$store as any).hasModule(STORE_KEY)) {
      this.$store.unregisterModule(STORE_KEY);
    }
  }

  onPageChange(page: number) {
    this.currentPage = page;
    this.loadLogs({ configId: this.configId, page });
  }

  statusLabel(status: string) {
    const map: Record<string, string> = {
      ok: 'Успех',
      error: 'Ошибка',
      running: 'Выполняется'
    };
    return map[status] || status;
  }

  statusTagType(status: string) {
    const map: Record<string, string> = {
      ok: 'is-success',
      error: 'is-danger',
      running: 'is-warning'
    };
    return map[status] || 'is-light';
  }

  sourceLabel(source: string) {
    const map: Record<string, string> = {
      scheduled: 'Планировщик',
      manual: 'Вручную',
      retry: 'Повтор'
    };
    return map[source] || source;
  }

  retry(row: any) {
    this.retryLog({ logId: row.id, configId: this.configId });
  }
}
